export const FLAG_GETTING_MAINTENANCE_BUS_GROUPS =
  'FLAG_GETTING_MAINTENANCE_BUS_GROUPS';
export const GET_MAINTENANCE_BUS_GROUPS = 'GET_MAINTENANCE_BUS_GROUPS';
export const CLEAR_MAINTENANCE_BUS_GROUPS = 'CLEAR_MAINTENANCE_BUS_GROUPS';
export const FLAG_MAINTENANCE_BUS_GROUP_ACTIVITY =
  'FLAG_MAINTENANCE_BUS_GROUP_ACTIVITY';
export const GET_MAINTENANCE_BUS_GROUP = 'GET_MAINTENANCE_BUS_GROUP';
export const CLEAR_MAINTENANCE_BUS_GROUP = 'CLEAR_MAINTENANCE_BUS_GROUP';
